// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeContentBlocksPage_wrapper__cgr5x"};